<template lang='pug'>
v-text-field(
  @focus="focused=true"
  @blur="focused=false"
  @input='$emit("input", $event)'
  @click:append='$emit("click:append")'
  :prefix='focused ? "+7" : ""'
  :value='value'
  v-bind='$attrs'
  mask=' (###) ###-##-##'
)
</template>

<script>
export default {
  props: ['value'],

  data: () => ({
    focused: false
  })
}
</script>
